// src/App.js
import React, { useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginEmail from './pages/LoginEmail';
import LoginPassword from './pages/LoginPassword';
import Dashboard from './pages/Dashboard';
import Shipping from './pages/Shipping';
import Users from './pages/Users';
import UserEdit from './pages/UserEdit';
import UserCreate from './pages/UserCreate';
import PasswordChange from './pages/PasswordChange';
import Logs from './pages/Logs';
import MainLayout from './layouts/MainLayout';
import Toasts from './components/ToastContainer';
import { useSelector, useDispatch } from 'react-redux';
import { addToast } from './redux/actions/authActions';

function App() {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const dispatch = useDispatch();

   // Use a ref to store the previous auth state
  const prevAuthRef = useRef(isAuthenticated);
  
  useEffect(() => {
    // When transitioning from not authenticated to authenticated
    if (!prevAuthRef.current && isAuthenticated) {
      dispatch(addToast({
        id: Date.now(),
        message: "You've been authenticated successfully.",
        variant: "success",
      }));
    }
    // When transitioning from authenticated to not authenticated
    if (prevAuthRef.current && !isAuthenticated) {
      dispatch(addToast({
        id: Date.now(),
        message: "You've been logged out.",
        variant: "danger",
      }));
    }
    prevAuthRef.current = isAuthenticated;
  }, [isAuthenticated, dispatch]);




  return (
    <Router>
      <>
      <Routes>
        {/* Public login routes */}
        <Route path="/login/email" element={<LoginEmail />} />
        <Route path="/login/password" element={<LoginPassword />} />

        {/* Fallback: if not authenticated, always show LoginEmail */}
        {/* {also add toast when logged out}   */}
        {!isAuthenticated && <Route path="*" element={<LoginEmail />} />}
        

        {/* Protected routes */}
        {isAuthenticated && (
          <Route path="/" element={<MainLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="shipping" element={<Shipping />} />
            <Route path="users" element={<Users />} />
            <Route path="users/create" element={<UserCreate />} /> 
            <Route path="users/edit/:userId" element={<UserEdit />} />
            <Route path="password-change" element={<PasswordChange />} />
            <Route path="logs" element={<Logs />} />
          </Route>
        )}
        </Routes>
        <Toasts />
        </>
    </Router>
  );
}

export default App;
